function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GALLERY_CONSTS, utils, isSEOMode, isPrerenderMode } from 'pro-gallery-lib';
import { GalleryComponent } from '../galleryComponent';
var BLURRY_IMAGE_REMOVAL_ANIMATION_DURATION = 1000;

var ImageItem = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(ImageItem, _GalleryComponent);

  function ImageItem(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.getImageContainer = _this.getImageContainer.bind(_assertThisInitialized(_this));
    _this.getImageContainerClassNames = _this.getImageContainerClassNames.bind(_assertThisInitialized(_this));
    _this.getImageElement = _this.getImageElement.bind(_assertThisInitialized(_this));
    _this.state = {
      isHighResImageLoaded: false
    };
    _this.removeLowResImageTimeoutId = undefined;
    _this.handleHighResImageLoad = _this.handleHighResImageLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ImageItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    try {
      if (typeof this.props.actions.setItemLoaded === 'function') {
        this.props.actions.setItemLoaded();
      }
    } catch (e) {
      console.error(e);
    }
  };

  _proto.handleHighResImageLoad = function handleHighResImageLoad(_ref) {
    var _this2 = this;

    var target = _ref.target;
    this.props.actions.setItemLoaded();
    target.style.opacity = '1';
    this.removeLowResImageTimeoutId = setTimeout(function () {
      _this2.setState({
        isHighResImageLoaded: true
      });

      _this2.removeLowResImageTimeoutId = undefined;
    }, BLURRY_IMAGE_REMOVAL_ANIMATION_DURATION);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeLowResImageTimeoutId !== undefined) {
      clearTimeout(this.removeLowResImageTimeoutId);
    }
  };

  _proto.getImageContainerClassNames = function getImageContainerClassNames() {
    var styleParams = this.props.styleParams;
    var imageContainerClassNames = ['gallery-item-content', 'image-item', 'gallery-item-visible', 'gallery-item', 'gallery-item-preloaded', styleParams.cubeImages && styleParams.cubeType === 'fit' ? 'grid-fit' : '', styleParams.imageLoadingMode === GALLERY_CONSTS.loadingMode.COLOR ? 'load-with-color' : ''].join(' ');
    return imageContainerClassNames;
  };

  _proto.getImageContainer = function getImageContainer(imageRenerer, classNames, extraNodes) {
    var _this$props = this.props,
        imageDimensions = _this$props.imageDimensions,
        id = _this$props.id,
        actions = _this$props.actions;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames,
      onTouchStart: actions.handleItemMouseDown,
      onTouchEnd: actions.handleItemMouseUp,
      key: 'image_container-' + id,
      "data-hook": 'image-item',
      style: imageDimensions.borderRadius ? {
        borderRadius: imageDimensions.borderRadius
      } : {}
    }, imageRenerer(), extraNodes);
  };

  _proto.getImageElement = function getImageElement() {
    var _this3 = this;

    var _this$props2 = this.props,
        alt = _this$props2.alt,
        imageDimensions = _this$props2.imageDimensions,
        createUrl = _this$props2.createUrl,
        id = _this$props2.id,
        settings = _this$props2.settings,
        styleParams = _this$props2.styleParams;
    var isHighResImageLoaded = this.state.isHighResImageLoaded;
    var imageProps = settings && settings.imageProps && typeof settings.imageProps === 'function' ? settings.imageProps(id) : {};

    var _ref2 = imageDimensions || {},
        marginLeft = _ref2.marginLeft,
        marginTop = _ref2.marginTop,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref2, ["marginLeft", "marginTop"]);

    var image = function image() {
      var imagesComponents = [];

      if (!isHighResImageLoaded) {
        var preload = null;

        var preloadProps = _objectSpread({
          className: 'gallery-item-visible gallery-item gallery-item-preloaded',
          key: 'gallery-item-image-img-preload',
          'data-hook': 'gallery-item-image-img-preload',
          loading: "lazy"
        }, imageProps);

        var preloadStyles = isPrerenderMode() ? {
          width: '100%',
          height: '100%'
        } : {};

        switch (styleParams.imageLoadingMode) {
          case GALLERY_CONSTS.loadingMode.BLUR:
            var imageStyles = _objectSpread(_objectSpread({}, restOfDimensions), {}, {
              backgroundSize: '0.3px',
              backgroundRepeat: 'repeat'
            });

            preload = /*#__PURE__*/React.createElement("img", _extends({
              alt: "",
              key: 'image_preload_blur-' + id,
              src: createUrl(GALLERY_CONSTS.urlSizes.RESIZED, isSEOMode() ? GALLERY_CONSTS.urlTypes.SEO : GALLERY_CONSTS.urlTypes.LOW_RES),
              style: _objectSpread(_objectSpread({}, imageStyles), preloadStyles)
            }, preloadProps));
            break;

          case GALLERY_CONSTS.loadingMode.MAIN_COLOR:
            preload = /*#__PURE__*/React.createElement("img", _extends({
              alt: "",
              key: 'image_preload_main_color-' + id,
              src: createUrl(GALLERY_CONSTS.urlSizes.PIXEL, isSEOMode() ? GALLERY_CONSTS.urlTypes.SEO : GALLERY_CONSTS.urlTypes.LOW_RES),
              style: _objectSpread(_objectSpread({}, restOfDimensions), preloadStyles)
            }, preloadProps));
            break;
        }

        imagesComponents.push(preload);
      }

      var shouldRenderHighResImages = !isPrerenderMode() && !utils.isSSR();

      if (shouldRenderHighResImages) {
        var highres = /*#__PURE__*/React.createElement("img", _extends({
          key: 'image_highres-' + id,
          className: 'gallery-item-visible gallery-item gallery-item-hidden gallery-item-preloaded',
          "data-hook": "gallery-item-image-img",
          alt: alt ? alt : 'untitled image',
          src: createUrl(GALLERY_CONSTS.urlSizes.RESIZED, isSEOMode() ? GALLERY_CONSTS.urlTypes.SEO : GALLERY_CONSTS.urlTypes.HIGH_RES),
          loading: "lazy",
          onLoad: _this3.handleHighResImageLoad,
          style: restOfDimensions
        }, imageProps));
        imagesComponents.push(highres);
      }

      return imagesComponents;
    };

    return image;
  };

  _proto.render = function render() {
    var imageRenderer = this.getImageElement();
    var imageContainerClassNames = this.getImageContainerClassNames();
    var renderedItem = this.getImageContainer(imageRenderer, imageContainerClassNames);
    return renderedItem;
  };

  return ImageItem;
}(GalleryComponent);

export { ImageItem as default };